import CryptoJS from 'crypto-js'

type CalcSignParams = Record<string, any>

const SECRET = 'WkRZME1UQmxPRGN4'
const DEFAULT_SECRET_KEY = CryptoJS.enc.Base64.parse(SECRET).toString(
  CryptoJS.enc.Utf8
)

export const calcSign = (
  jsonObj: CalcSignParams,
  secretKey: string = DEFAULT_SECRET_KEY
) => {
  const str = JSON.stringify(jsonObj) + secretKey
  const prefix = str.substring(0, 10)
  const middle = str.substring(10, str.length - 10)
  const postfix = str.substring(str.length - 10)
  const mixedStr = postfix + middle + prefix
  return CryptoJS.MD5(mixedStr).toString()
}
